import { CanActivateFn, Router } from '@angular/router';
import { Logout } from '../../store/auth/auth.actions';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { APP_ROUTES } from '../enum/app-routes.enum';

export const AuthorizationGuard: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);

    if (store.snapshot().auth.token) {
        return true;
    }
    store.dispatch(new Logout());
    router.navigate([`/${APP_ROUTES.LOGIN}`]);
    return false;
};
